import { useQuery } from "@tanstack/react-query";

import type { paths } from "@/api/types";
import type { Result } from "@/shared/api";
import { apiGet, qk } from "@/shared/api";

export type ProjectSettings = Result<paths["/api/v1/admin/settings"]["get"]>;

export function useSettings() {
  return useQuery({
    queryKey: qk.settings(),
    queryFn: ({ signal }) => apiGet("/api/v1/admin/settings", { signal }),
  });
}
